import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const enum notificationsStatuses {
  IDLE = 'IDLE',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

type NotificationsSlice = {
  status: `${notificationsStatuses}`;
  setStatus: (newStatus: `${notificationsStatuses}`) => void;
};

export const useNotificationsStore = create<NotificationsSlice>()(
  persist(
    (set) => ({
      status: notificationsStatuses.IDLE,
      setStatus: (newStatus) => {
        set(() => ({
          status: newStatus,
        }));
      },
    }),
    {
      name: 'notifications-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
